<template lang="pug">
  div.home
    h1 Embedded Programmatic
    p This screen assumes your system has all information except elements in the form.
    div.form
      h3 We need a little more information to quote you...
      form#quote.vertical.wide
        fieldset
          label Miles Driven Per Year
            input(type="text" v-model="modifiableRequest.car.milesPerYear")
          label Odometer
            input(type="text" v-model="modifiableRequest.car.odometer")
          label Years to Own
            input(type="text" v-model="modifiableRequest.car.yearsToOwn")
    action-button(v-if="!ready" title="Get Quotes" :disabled="false" :loading="loading" @click="loadRates")
    swbc-sales-frame.frame(v-if="(loading || ready)"
                          v-show="ready"
                          mode="selection"
                          :quote="modifiableRequest"
                          @error="loadingDone()"
                          @quote="loadingDone"
                          @reservation="acceptReservation")
    p(v-if="loading") Loading your rates...
    p(v-else-if="!loading && hadError") There was an error quoting. Maybe adjust settings?
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ActionButton from '@/components/ActionButton'
  import SwbcSalesFrame from '@/components/SwbcSalesFrame'
  export default {
    name: 'EmbeddedProgrammatic',
    data () {
      return {
        loading: false,
        ready: false,
        hadError: false,
        modifiableRequest: {}
      }
    },
    methods: {
      ...mapActions(['setReservation']),
      acceptReservation (reservation) {
        this.setReservation(reservation)
        this.$router.push('/reservation')
      },
      loadRates () {
        this.loading = true
      },
      loadingDone (rates) {
        this.hadError = !rates
        this.ready = !!rates
        // Have to do this because v-if + v-show
        //   logic calls double render of frame otherwise
        setTimeout(() => {
          this.loading = false
        })
      }
    },
    computed: {
      ...mapGetters(['quoteRequest'])
    },
    created () {
      this.modifiableRequest = this.quoteRequest
    },
    components: {
      ActionButton,
      SwbcSalesFrame
    }
  }
</script>

<style lang="sass">
  div.form
    padding: 20px
  div.container
    border: 1px solid black
  .frame
    border: none
    height: 700px
    width: 800px
  #quote
    display: flex
    flex-direction: column
    justify-content: flex-start
    align-items: center
    margin: 0 auto
</style>
